var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_c('b-button',{staticClass:"ml-2",attrs:{"size":"sm","variant":"danger"},on:{"click":_vm.downloadPdf}},[_vm._v(" PDF ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }